export class PhaseSelectorApiModel {
  public static anytime: PhaseSelectorApiModel = {
    Id: null,
    Name: 'Anytime',
    IsCompleted: false,
    HasEndOfPhaseForm: false,
    CompletedOn: null,
    CompletedBy: null
  };
  public static allPhases: PhaseSelectorApiModel = {
    Id: undefined,
    Name: 'Any phase due',
    IsCompleted: false,
    HasEndOfPhaseForm: false,
    CompletedOn: null,
    CompletedBy: null
  };

  public Id: number;
  public Name: string;
  public IsCompleted: boolean;
  public HasEndOfPhaseForm: boolean;
  public CompletedOn: Date;
  public CompletedBy: string;
}
